module.exports = __webpack_public_path__ + "c_static/img/A1-5-1淘气值.16f33a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/完善资料/A1-5-1淘气值.jpg
// module id = GPAb
// module chunks = 33